export default __webpack_public_path__ + "images/0xd67a097dce9d4474737e6871684ae3c05460f571.png";